/**
 * Toggle Text on click
 * @module toggleText
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'toggleText';
export const ACTIVE_CLASS = 'toggle-text--is-active';

export const DEFAULTS = {
  toggleTextTargetClass: '',
  toggleTextDefault: '',
  toggleTextAlt: '',
  toggleTextPoliteness: 'assertive',
};

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const makeAccessible = ({ toggleTextTargetClass, toggleTextPoliteness }) => {
  $(`.${toggleTextTargetClass}`).each(function ariaLiveTriggers() {
    const $el = $(this);
    if (!$el.data('no-aria-live')) {
      $el.attr('aria-live', toggleTextPoliteness);
    }
  });
};
/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, { toggleTextTargetClass, toggleTextDefault, toggleTextAlt }) => {
  $el.on('click.triggerText', (evt) => {
    evt.preventDefault();
  const isActive = $el.hasClass(ACTIVE_CLASS);
  $(`.${toggleTextTargetClass}`).each(function changeText() {
    const $changingEl = $(this);
    if ($changingEl.data('toggle-text-revese')) {
      $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
    } else {
      $changingEl.text(isActive ? toggleTextDefault : toggleTextAlt);
    }
  });
  $el.toggleClass(ACTIVE_CLASS);
});
};
const hasHash = ($el) => {
  const href = $el.attr('href');
  if (href) {
    if (href.toLowerCase().indexOf('#') !== -1 && href.length > 1) {
      return href;
    }
  }
  return false;
};
/**
 * Give <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $el - button /element that toggles text
 */
const makeUniqueHash = ($el) => {
  if ($el.is('a') && !hasHash($el)) {
    $el.attr('href', `#toggle-text-uid-${Math.ceil(Math.random() * 10000000000)}`);
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function toggleText(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  makeAccessible(opts);
  makeUniqueHash($el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, toggleText);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-text.js